'use client';

import { Button } from '@sgcmpteltd/uikit-react';
import {
  BUTTON_VARIANT_CONTAINED,
} from '@sgcmpteltd/uikit-react/components/button';
import Image from 'next/image';
import type { JSX } from 'react';
import { useState } from 'react';

import { joinSgcmMedia } from '@/utils/url/join/public';

import styles from './error.module.scss';

interface ErrorProps {
  error: Error;
  reset: () => void;
}

const Error = ({ error, reset }: ErrorProps): JSX.Element => {
  const [imageError, setImageError] = useState(false);
  const imageSrc = joinSgcmMedia('/public/shared/error-500.svg').toString();

  if (process.env.NODE_ENV === 'development') {
    throw error;
  }

  return (
    <div className={styles.containerRoot}>
      {!imageError
        ? (
          <Image
            alt="error"
            className={styles.imgError}
            height={398}
            src={imageSrc}
            width={339}
            onError={() => setImageError(true)} />
        )
        : null}
      <h3 className={styles.textError}>
        Something went wrong!
      </h3>
      <Button
        className={styles.btnTryAgain}
        variant={BUTTON_VARIANT_CONTAINED}
        onClick={reset}>
        Try again
      </Button>
    </div>
  );
};

export default Error;
